<div class="c-loading-spinner">
    <div class="loading-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>
